<div>
  <input
    #search
    type="search"
    class="form-control"
    placeholder="Ex. Drottninggatan eller Stockholm"
    [value]="
      !!modelAndDealerService.dealerSearchInput
        ? modelAndDealerService.dealerSearchInput
        : ''
    "
    maxlength="30"
    (keyup.enter)="onSearch(search.value)"
  />
</div>

<div class="d-flex pt-4">
  @if (geoLocationEnabled()) {
    <div class="pb-2 my-auto d-flex" (click)="useClientLocation()">
      <a class="theme-color-primary fs-16" role="button"
        >{{ "maps.myLocation" | translate }}
      </a>
      <span class="ps-1 my-auto text-with-icon">
        <i class="fas fa-map-marker-alt"></i>
      </span>
    </div>
  }
  <div class="ms-auto my-auto d-flex" (click)="toggleMap()">
    <a class="theme-color-primary fs-16" role="button"
      >{{ (!!mapEnabled ? "maps.hideMap" : "maps.showMap") | translate }}
    </a>
    <span class="ps-1 my-auto text-with-icon">
      <i class="fas fa-map-marked-alt"></i>
    </span>
  </div>
</div>

@if (mapEnabled) {
  <div class="mw-xl-50 mw-sm-1000 pt-2">
    <google-map
      [center]="mapLocation"
      height="300px"
      width="100%"
      [zoom]="zoom"
      [options]="options"
      (mapClick)="moveMapLocation($event)"
    >
      @if (!!allLocations()) {
        @for (location of allLocations(); track location) {
          <map-marker
            [position]="
              location | googleMapsLatLngLit: stockholmCenterCoordinates
            "
            [options]="
              mapLocation.lng === location.longitude &&
              mapLocation.lat === location.latitude
                ? selectedPlaceIcon
                : placeIcon
            "
            (mapClick)="onMarkerClick($event)"
          ></map-marker>
        }
      }
      @if (!!clientLocation()) {
        <map-marker
          [position]="
            clientLocation() | googleMapsLatLngLit: stockholmCenterCoordinates
          "
          [options]="clientIcon"
        ></map-marker>
      }
    </google-map>
  </div>
}
